"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Deferred = void 0;
Object.defineProperty(exports, "DeferredError", {
  enumerable: true,
  get: function get() {
    return _DeferredError["default"];
  }
});
exports["default"] = exports.DeferredGroup = void 0;
var _DeferredError = _interopRequireDefault(require("../../Shared/ErrorTypes/DeferredError"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
 * @private
 * @type {{}}
 */
var promises = {};
var Deferred = exports.Deferred = /*#__PURE__*/function () {
  function Deferred() {
    var _this = this;
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    _classCallCheck(this, Deferred);
    _defineProperty(this, "resolve", function () {
      _this.remove();
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this._resolve.apply(0, args);
    });
    _defineProperty(this, "reject", function () {
      _this.remove();
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      _this._reject.apply(0, args);
    });
    if (promises[name]) {
      throw new _DeferredError["default"]('Instance already exists with the name: ' + name);
    }
    this.name = name;
    this.promise = new Promise(function (resolve, reject) {
      _this._resolve = resolve;
      _this._reject = reject;
    });
    if (name) {
      promises[name] = this;
    }
  }
  _createClass(Deferred, [{
    key: "remove",
    value: function remove() {
      delete promises[this.name];
    }
  }, {
    key: "then",
    value: function then(fn) {
      this.promise.then(fn);
    }
  }], [{
    key: "get",
    value: function get(name) {
      if (!promises[name]) {
        throw new _DeferredError["default"]('Instance does not exist with the name: ' + name);
      }
      return promises[name];
    }
  }]);
  return Deferred;
}();
var _default = exports["default"] = Deferred;
var DeferredGroup = exports.DeferredGroup = /*#__PURE__*/function () {
  function DeferredGroup() {
    _classCallCheck(this, DeferredGroup);
    _defineProperty(this, "deferredList", []);
    if (arguments.length > 0) {
      this.deferredList = this.deferredList.concat(arguments);
    }
  }
  _createClass(DeferredGroup, [{
    key: "create",
    value: function create() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var deferred = new Deferred(name);
      this.add(deferred);
      return deferred;
    }
  }, {
    key: "createResolver",
    value: function createResolver() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this.create(name).resolve;
    }
  }, {
    key: "add",
    value: function add(deferred) {
      this.deferredList.push(deferred);
    }
  }, {
    key: "then",
    value: function then(fn) {
      return Promise.all(this.deferredList.map(function (d) {
        return d.promise;
      })).then(fn);
    }
  }]);
  return DeferredGroup;
}();